import {getPageSlug} from './utils';

const prefixPage = 'page://';

const plugin = function (editor, opts = {}) {
    const {Components, Blocks} = editor;
    const wrapperModel = Components.getType('wrapper').model;
    const wrapperDefaults = wrapperModel.getDefaults();

    Components.addType('wrapper', {
        model: {
            defaults: {
                emptyState: {styleIn: 'height: 100vh', styleOut: 'padding: 0;'},
                stylable: [
                    ...wrapperDefaults.stylable,
                    // For now, the whole Typography section is visible because we don't handle
                    // properly each property visibility, so this might change in case that will
                    // be fixed (we'll need to indicate all Typography properties in that case).
                    'font-family',
                ],
            }
        }
    });

    Components.addType('text', {
        model: {
            defaults: {
                highlightable: false,
                emptyState: {styleIn: 'min-height: auto; font-size: inherit;'},
            }
        }
    });

    Components.addType('image', {
        model: {
            defaults: {
                traits: [
                    'alt',
                    {
                        type: 'checkbox',
                        name: 'loading',
                        valueTrue: 'lazy',
                    }
                ],
            },
        },
    });

    const linkClass = 'gjs-link';
    const typeLink = Components.getType('link');
    const typyLinkModel = typeLink.model;
    Components.addType('link', {
        model: {
            defaults: {
                emptyState: true,
                attributes: {class: linkClass},
                traits: [
                    'title',
                    {
                        type: 'checkbox',
                        name: 'target',
                        valueTrue: '_blank',
                    },
                    {
                        type: 'href',
                        name: 'href',
                    },
                ],
                styles: `
            .${linkClass} {
              vertical-align: top;
              max-width: 100%;
              display: inline-block;
              text-decoration: none;
              color: inherit;
            }
          `,
            },

            getAttrToHTML() {
                const attr = typyLinkModel.prototype.getAttrToHTML.apply(this);
                const {href} = attr;

                if (href) {
                    if (href.indexOf(prefixPage) === 0) {
                        const pageId = href.replace(prefixPage, '');
                        const page = editor.Pages.get(pageId);
                        attr.href = page ? `./${getPageSlug(editor, page)}` : '##';
                    }
                }

                return attr;
            }
        },
    });

    editor.DomComponents.addType('text', {
        isComponent: (el) => {
            return (el.tagName === 'SPAN' || el.tagName === 'STRONG') && (el.classList.contains('spec-graph-title') || el.classList.contains('spec-graph-sub-title'));
        },
        model: {
            defaults: {
                type: 'text',
                tagName: 'span',
                draggable: false,
                droppable: false,
                editable: true,
                toolbar: [
                    {
                        attributes: {class: 'table-insert-column-left', label: '왼쪽에 열 추가'},
                        command: 'add-table-insert-column-left'
                    },
                    {
                        attributes: {class: 'table-insert-row-top', label: '위에 행 추가'},
                        command: 'add-table-insert-row-top'
                    },
                    {
                        attributes: {class: 'table-insert-row-bottom', label: '아래에 행 추가'},
                        command: 'add-table-insert-row-bottom'
                    },
                    {
                        attributes: {class: 'table-insert-column-right', label: '오른쪽에 열 추가'},
                        command: 'add-table-insert-column-right'
                    }, {
                        attributes: {class: 'table-delete-column', label: '열 삭제'},
                        command: 'delete-table-column'
                    }, {
                        attributes: {class: 'table-delete-row', label: '행 삭제'},
                        command: 'delete-table-row'
                    }
                ],
            },
        },
    });
    editor.DomComponents.addType('image-link', {
        isComponent: (el) => {
            if (el.tagName !== 'IMG') return false;
            if (el.parentElement.tagName === 'A') {
                // return {type: 'image-link', tagName: 'Image-Link'};
                return true;
            }
            return false;
        },
        extend: 'image',
        model: {
            defaults: {
                type: 'image',
                tagName: 'img',
                customLabel: 'Image Link',
                draggable: false,
                droppable: false,
                editable: true,
                toolbar: [{
                    attributes: {
                        class: 'disconnect_link',
                        label: '연결 끊기',
                    },
                    label: '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 107.68"><defs><style>.cls-1{fill-rule:evenodd;}</style></defs><title>remove-link</title><path class="cls-1" d="M97.62,40.71A25.26,25.26,0,1,1,72.37,66,25.25,25.25,0,0,1,97.62,40.71ZM51,31.51a5.35,5.35,0,0,1-7.57-7.57L60.79,6.62c5-5,12-7,19-6.56a30.61,30.61,0,0,1,19.37,8.5,30.61,30.61,0,0,1,8.5,19.37,28.07,28.07,0,0,1-.28,6.29,33.23,33.23,0,0,0-9.72-1.44h-.88A17.64,17.64,0,0,0,97,28.6a19.71,19.71,0,0,0-5.41-12.47,19.69,19.69,0,0,0-12.47-5.41c-4.08-.25-8,.8-10.72,3.47L51,31.51ZM63.8,36.32a5.35,5.35,0,0,1,7.56,7.57L43.88,71.36a5.35,5.35,0,0,1-7.56-7.56L63.8,36.32Zm-7.33,40A5.35,5.35,0,1,1,64,83.92L46.89,101.07c-5,5-12,7-19,6.55a30.64,30.64,0,0,1-19.37-8.5A30.61,30.61,0,0,1,.06,79.75c-.44-7,1.56-14,6.56-19L23.76,43.64a5.35,5.35,0,1,1,7.57,7.57L14.19,68.36C11.52,71,10.47,75,10.72,79.08a19.69,19.69,0,0,0,5.41,12.47A19.71,19.71,0,0,0,28.6,97c4.08.26,8-.79,10.72-3.46L56.47,76.35Zm55.07-13.07v5.36a2,2,0,0,1-2,2H85.68a2,2,0,0,1-2-2V63.28a2,2,0,0,1,2-2h23.88a2,2,0,0,1,2,2Z"/></svg>',
                    command: 'disconnect-img-link'
                }],
            }
        },
    })

    editor.DomComponents.addType('image', {
        isComponent: (el) => {
            return el.tagName === 'IMG';
        },
        model: {
            defaults: {
                type: 'image',
                tagName: 'img',
                draggable: false,
                droppable: false,
                editable: true,
                toolbar: [
                    {
                        attributes: {
                            class: 'convert_link',
                            label: '링크이미지로 변경'
                        },
                        command: 'convert-img-link'
                    }
                ],
            },
        },
    });

    editor.BlockManager.add('image-link-block', {
        label: 'Image with Link',
        content: {
            type: 'image-link',
            attributes: {class: 'img-responsive'}
        }

    })

    Blocks.add('link', {
        label: 'Link',
        content: {
            type: 'link',
            content: 'Link',
            style: {color: '#d983a6', padding: '10px'}
        }
    }, {merge: true});

    Components.addType('select', {
        model: {
            defaults: {
                traits: [
                    {name: 'name'},
                    {
                        type: 'checkbox',
                        name: 'required',
                    },
                    {
                        name: 'options',
                        type: 'stack',
                        getValue({component}) {
                            return component.components().map(cmp => ({
                                id: cmp.getAttributes()['value'] || '',
                                label: cmp.getInnerHTML()
                            }));
                        },
                        setValue: ({
                                       component,
                                       value,
                                       emitUpdate,
                                   }) => {
                            component.components(value.map((v) => ({
                                type: 'option',
                                content: v.label,
                                attributes: {value: v.id}
                            })));
                            emitUpdate();
                        },
                        // @ts-ignore
                        properties: [
                            {name: 'id'},
                            {name: 'label'},
                        ]
                    },
                ],
            },
        },
    });
}

export default plugin;